import type { FC, ReactChild } from 'react';
import React from 'react';

import type { UploadContextType } from './../ricos-types';
import type { UpdateService } from './../_shared/upload/update-service';
import type { IUploadService } from './../_shared/upload/upload-service';

type UploadContextProps = {
  uploadService: IUploadService;
  updateService: UpdateService;
  children: ReactChild;
};

export const UploadContext = React.createContext<UploadContextType>(
  null as unknown as UploadContextType
);

export const UploadContextProvider: FC<UploadContextProps> = ({
  uploadService,
  updateService,
  children,
}) => {
  return (
    <UploadContext.Provider value={{ uploadService, updateService }}>
      {children}
    </UploadContext.Provider>
  );
};
